import { render, staticRenderFns } from "./recently-viewed.vue?vue&type=template&id=23f9db71"
import script from "./recently-viewed.vue?vue&type=script&lang=js"
export * from "./recently-viewed.vue?vue&type=script&lang=js"
import style0 from "./recently-viewed.vue?vue&type=style&index=0&id=23f9db71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Avatar: require('/app/components/ui/Avatar.vue').default})
